/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { attributeBindings, classNames } from '@ember-decorators/component';

@classNames('timetable-period')
@attributeBindings('style')
export default class TimetablePeriod extends Component {
  cellHeight = 48;

  @computed('period.{duration,startTime}')
  get style() {
    let style = '';
    // The API does not send an empty startTime (0). Then mins is NaN, and the
    // period stays at the top of the cell.
    let mins = parseInt((this.get('period.startTime') ?? '').split(':')[1], 10);
    let duration = this.get('period.duration');
    let cellHeight = this.cellHeight;
    if (mins > 0) {
      style += `top:${(mins / 60) * cellHeight}px;`;
    }
    style += `height:${Math.floor((duration / 60) * cellHeight) - 1}px;`;

    return htmlSafe(style);
  }
}
